import { render } from "./order.vue?vue&type=template&id=cccd7eb0&scoped=true&ts=true"
import script from "./order.vue?vue&type=script&lang=tsx"
export * from "./order.vue?vue&type=script&lang=tsx"

import "./order.vue?vue&type=style&index=0&id=cccd7eb0&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cccd7eb0"]])

export default __exports__